import React, { useState } from "react";
import "../assets/css/style.css";
import image1 from "../assets/css/img/pic11.jpeg";
import image2 from "../assets/css/img/pic22.jpeg";
import image3 from "../assets/css/img/pic33.JPG";
// import image4 from "../assets/css/img/pic44.jpeg";
import image5 from "../assets/css/img/pic55.JPG";
import image6 from "../assets/css/img/pic66.JPG";
import image7 from "../assets/css/img/pic77.JPG";
import image8 from "../assets/css/img/image11.jpeg";
import image9 from "../assets/css/img/image22.jpeg";
import image10 from "../assets/css/img/image33.jpeg";
import image11 from "../assets/css/img/image44.jpeg";
import image12 from "../assets/css/img/image55.jpeg";
import image13 from "../assets/css/img/image55.jpeg"
import shock from "../assets/css/img/shock.png";

const Projects = () => {
  const [showAll, setShowAll] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [showDescription, setShowDescription] = useState(null);

  const handleToggleView = () => {
    setShowAll(!showAll);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setShowAll(true); // Show all projects when a category is selected
  };

  const handleToggleDescription = (index) => {
    if (showDescription === index) {
      setShowDescription(null); // Hide the description
    } else {
      setShowDescription(index); // Show the description for the clicked project
    }
  };

  const projects = [
    {
      img: image6,
      title: "St Anthonys-50KW",
      description: "Description for Additional Project 1...",
      category: "Commercial",
    },
    
    {
      img: image2,
      title: "Kamson Health Care-160KW",
      description: "Description for 500KW Navodaya Hospital...",
      category: "Commercial",
    },
    {
      img: image3,
      title: "Manjeera Hospital-60KW",
      description: "Description for BEGAM PET AIRPORT FOOTINGS...",
      category: "Commercial",
    },
    // {
    //   img: image4,
    //   title: "60 kW Hindu Public School",
    //   description: "Description for Additional Project 1...",
    //   category: "Commercial",
    // },
    {
      img: image5,
      title: "NPPL-1MW",
      description: "Description for Additional Project 2...",
      category: "Commercial",
    },
  
 
    {
      img: image8,
      title: "Indu Fortune Feilds-120KW",
      description: "Description for Additional Project 1...",
      category: "Residential",
    },
    {
      img: image9,
      title: "Myhome Ankura-10KW",
      description: "Description for Additional Project 1...",
      category: "Residential",
    },
    {
      img: image10,
      title: "BHEL-10KW",
      description: "Description for Additional Project 1...",
      category: "Residential",
    },
    // {
    //   img: image11,
    //   title: "5 kW Gandhi",
    //   description: "Description for Additional Project 1...",
    //   category: "Residential",
    // },
    {
      img: image1,
      title: "Compass Food India-190KW",
      description: "Description for GVMC Water Tanks Vizag...",
      category: "Commercial",
    },
    {
      img: image12,
      title: "10KW-Srila Pride ",
      description: "Description for Additional Project 1...",
      category: "Residential",
    },
    {
      img: image7,
      title: 'SVRE-400',
      description: 'Description for Additional Project 1...',
      category: 'Commercial'
    },
    {
      img: image11,
      title: "Banjara Hills-5KW",
      description: "Description for Additional Project 1...",
      category: "Residential",
    },
    
  ];
  const filteredProjects =
    selectedCategory === "All"
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  const visibleProjects = showAll
    ? filteredProjects
    : filteredProjects.slice(0, 4);

  return (
    <>
      <section id="Project">
     <div className="container projects-header mb-5"> 
         <div className="row align-items-center">
          <h1 className="green-heading text-center">
            <img src={shock} className="shock" />
            &nbsp;Projects
          </h1>
{/* 
          <h3 className="p-3 projects-subtitle text-center">
            Budding Leaf Projects - Solar Power Systems
          </h3> */}
          <div className="projects-filters container">
            <button
              className={`filter-button ${
                selectedCategory === "All" ? "active" : ""
              }`}
              onClick={() => handleCategoryChange("All")}
            >
              All Projects
            </button>
            <button
              className={`filter-button ${
                selectedCategory === "Commercial" ? "active" : ""
              }`}
              onClick={() => handleCategoryChange("Commercial")}
            >
              Commercial
            </button>
            <button
              className={`filter-button ${
                selectedCategory === "Residential" ? "active" : ""
              }`}
              onClick={() => handleCategoryChange("Residential")}
            >
              Residential
            </button>
          </div>
          <div className="text-end container">
            <button className="btn review-button" onClick={handleToggleView}>
              {showAll ? "See less" : "See More"}
            </button>
          </div>

          <div className="projects-cards container">
            <div className="row justify-content-center">
              {visibleProjects.map((project, index) => (
                <div key={index} className="col-md-3 col-sm-6 ">
                  <div className="card">
                    <div className="card-img-container">
                      <img
                        src={project.img}
                        alt={project.title}
                        className="card-img"
                      />
                      {showDescription === index && (
                        <div className="card-description">
                          <p>{project.description}</p>
                        </div>
                      )}
                    </div>
                    <div className="card-body">
                      <h5 className="installation-title">{project.title}</h5>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        </div>  
     </section> 


   </>
  );
};

export default Projects;
